// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__ukaGX","card":"style_card__Va3cq","content":"style_content__iKwuQ","mobileLayout":"style_mobileLayout__z0UrI"};